import { Vector3 } from './Vector3'
import type { Vector3Like } from './types'

/** The plane normal . p + constant = 0 (`normal` is unit length). */
export class Plane {
  readonly isPlane = true
  /** As three's Plane, the normal passed in is kept (not copied). */
  constructor(public normal: Vector3 = new Vector3(1, 0, 0), public constant = 0) {}

  set(normal: Vector3Like, constant: number): this {
    this.normal.copy(normal)
    this.constant = constant
    return this
  }

  setFromNormalAndCoplanarPoint(normal: Vector3Like, point: Vector3Like): this {
    this.normal.copy(normal)
    this.constant = -(point.x * this.normal.x + point.y * this.normal.y + point.z * this.normal.z)
    return this
  }

  distanceToPoint(point: Vector3Like): number {
    return this.normal.dot(point) + this.constant
  }

  clone(): Plane {
    return new Plane(this.normal.clone(), this.constant)
  }
}
